/**
 * Errors of the public (customer-facing, no-auth) pages. POS-I233: a read-only business answers
 * 403 {code: 'BUSINESS_UNAVAILABLE'}; the page shows a LOCAL (en/ur/ro) neutral sentence for that
 * code and the server text for anything else. Never a billing word, never the staff banner.
 */
export const BUSINESS_UNAVAILABLE_CODE = 'BUSINESS_UNAVAILABLE';

export class PublicApiError extends Error {
  code?: string;
  constructor(message: string, code?: string) {
    super(message);
    this.name = 'PublicApiError';
    this.code = code;
  }
}

export function publicApiError(body: { message?: string | string[]; code?: string } | null | undefined): PublicApiError {
  const m = body?.message;
  const text = Array.isArray(m) ? m[0] : m;
  return new PublicApiError(text ?? 'Request failed', typeof body?.code === 'string' ? body.code : undefined);
}

/** The text to show for a failed public request. `unavailable` is the local neutral sentence. */
export function publicErrorText(err: unknown, unavailable: string, fallback: string): string {
  if (err instanceof PublicApiError && err.code === BUSINESS_UNAVAILABLE_CODE) return unavailable;
  const msg = err instanceof Error ? err.message : '';
  return msg || fallback;
}
